import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f9e4aa2")

_pushScopeId("data-v-7f9e4aa2")
const _hoisted_1 = { class: "signup-privacy-policy" }
const _hoisted_2 = { class: "signup-privacy-policy__content" }
const _hoisted_3 = { class: "agree" }
const _hoisted_4 = { class: "p-field-checkbox" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "agree1",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Shaxsiy ma'lumotlarni to'plash va ulardan foydalanishga rozilik "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(majburiy)")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<table class=\"-medium\" data-v-7f9e4aa2><thead data-v-7f9e4aa2><tr data-v-7f9e4aa2><th data-v-7f9e4aa2>Maqsad</th><th data-v-7f9e4aa2>Ekementlar</th><th data-v-7f9e4aa2>Saqlash muddati</th></tr></thead><tbody data-v-7f9e4aa2><tr data-v-7f9e4aa2><td data-v-7f9e4aa2><span data-v-7f9e4aa2>Foydalanuvchilarni identifikatsiyalash va a&#39;zolikni boshqarish</span></td><td data-v-7f9e4aa2><span data-v-7f9e4aa2>Elektron pochta, F.I.SH, mobil telefon raqami, jinsi</span></td><td data-v-7f9e4aa2><span data-v-7f9e4aa2>Foydalanuvchi a&#39;zolikdan chiqqandan so&#39;ng ma&#39;lumotlar darhol o&#39;chiriladi</span></td></tr></tbody></table>", 1)
const _hoisted_7 = { class: "agree" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "agree2",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Onlayn(video) konsultatsiya paytida videodan foydalanishga rozilik bildirish "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(majburiy)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, " Vrach retseptni yozib berishi uchun video konsultatsiya amalga oshirilayotganda tashxis qo'yish uchun zarur bo'lgan jarohatlar va yaralar singari tashqi tana rasmlari saqlanishi mumkin va ushbu rasmlar retsept yozishdan tashqari boshqa maqsadlarda foydalanilmaydi. ", -1)
const _hoisted_12 = { class: "agree" }
const _hoisted_13 = { class: "p-field-checkbox" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "agree3",
  class: "-medium"
}, [
  /*#__PURE__*/_createTextVNode(" Ro'yxatdan o'tishga oid bildirishnomalarni bilan tanishish va ularga rozilik bildirish "),
  /*#__PURE__*/_createVNode("span", { class: "-required" }, "(majburiy)")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "ps" }, [
  /*#__PURE__*/_createVNode("span", null, "Yolg'on ma'lumotlar yoki shaxsiy ma'lumotlarni o'girlash uchun javobgarlik"),
  /*#__PURE__*/_createVNode("ol", null, [
    /*#__PURE__*/_createVNode("li", null, " 1. Agar foydalanuvchi tizimda roʻyxatdan oʻtayotganda ism-sharifi yoki tugʻilgan sanasi va h.k. bandlarga soxta maʼlumotlarni kiritsa yoki boshqa shaxsning shaxsiy maʼlumotlarini oʻgʻirlasa, tegishli qonun va qoidalarga muvofiq jinoiy javobgarlikka tortilishi mumkin. "),
    /*#__PURE__*/_createVNode("li", null, " 2. Agar foydalanuvch 1-bandda ko'rsatilganidek soxta ma'lumotlar yoki boshqa birovning nomidan foydalangan holda ushbu xizmatdan foydalansa, kompaniya va tibbiy muassasa xizmatdan foydalanish natijasida yetkazilgan har qanday zararni foydalanuvchiga qoplash berish uchun javobgar emas. "),
    /*#__PURE__*/_createVNode("li", null, " 3. Agar foydalanuvchi soxta ma'lumotlar yoki birovning shaxsiy ma'lumotlarini o'g'irlashi tufayli kompaniya yoki tibbiyot muassasasiga zarar yetkazilsa, mazkur foydalanuvchi kompaniya va tibbiyot muassasasiga yetkazilgan zararni qoplash uchun javobgar bo'ladi. ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Checkbox, {
            id: "agree1",
            modelValue: _ctx.state.agree1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.agree1 = $event)),
            class: "-royalBlue check-box",
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Checkbox, {
            id: "agree2",
            modelValue: _ctx.state.agree2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.agree2 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_9
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Checkbox, {
            id: "agree3",
            modelValue: _ctx.state.agree3,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.agree3 = $event)),
            binary: true,
            class: "-royalBlue check-box"
          }, null, 8, ["modelValue"]),
          _hoisted_14
        ]),
        _hoisted_15,
        _hoisted_16
      ])
    ])
  ]))
})